export const firebaseConfig = {
  apiKey: "AIzaSyD3xGOYp56bHq3GZmugroUhjgp2ZM3c7-c",
  authDomain: "doxpro-5e213.firebaseapp.com",
  projectId: "doxpro-5e213",
  storageBucket: "doxpro-5e213.appspot.com",
  messagingSenderId: "684273942666",
  appId: "1:684273942666:web:17d7e3820a20e44cc6ad73",
  measurementId: "G-H16XBG2P9D"
};
